import { white } from "design-system/colors";
import { Stop } from "types";

/**
 * Creates a Google Maps marker for a trip stop.
 * 
 * @param stop - The stop data containing coordinates and stop index
 * @param map - The Google Maps instance
 * @param svg - The SVG icon URL for the marker
 * @param label - Optional label number to display on the marker
 * @returns Google Maps Marker instance or null if coordinates are unavailable
 * 
 * @remarks
 * Coordinates may be null when trip data is masked for privacy reasons,
 * such as when a trip has expired and the user is not authenticated.

 */
export const createTripStopMarker = async (
  stop: Stop,
  map: google.maps.Map,
  svg: string,
  label: number | null
) => {
  const { coordinates, stopIndex } = stop;
  
  // Return null if coordinates are not available (e.g., when data is masked for expired trips)
  if (!coordinates) {
    return null;
  }
  
  const tripLocationMarker = new google.maps.Marker({
    position: { lat: coordinates.x, lng: coordinates.y },
    map: map,
    icon: {
      url: svg,
      anchor: new google.maps.Point(12, 20),
      labelOrigin: new google.maps.Point(17, 15),
      scaledSize: new google.maps.Size(label ? 35 : 50, label ? 35 : 50),
    },
    label: label
      ? {
          text: label.toString(),
          color: white,
          fontWeight: "600",
          fontSize: "12px",
          fontFamily: "Poppins",
        }
      : null,
  });
  tripLocationMarker.set("stopIndex", stopIndex);

  return tripLocationMarker;
};
